import { isAppleSafari } from ".";
import { addAccount } from "../actions/addFeedActions";
import { HOST_URL, LIVE_API } from "../actions/api";
import { FACEBOOK_CLIENT_ID, GOOGLE_CLIENT_ID, INSTA_CLIENT_ID, SLACK_CLIENT_ID, TWITTER_CLIENT_ID, YAMMER_CLIENT_ID } from "../actions/constant";
import { toast } from "react-toastify";

export const getTwitterCode = () => {
    const url = `https://x.com/i/oauth2/authorize?response_type=code&client_id=${TWITTER_CLIENT_ID}&redirect_uri=${HOST_URL}/feeds/authCallback/&scope=tweet.read%20users.read%20follows.read%20follows.write%20list.read%20offline.access&state=twitter&code_challenge=challenge&code_challenge_method=plain`;
    window.open(url, "_blank", "width=786,height=786");
};

export const getVimeoCode = () => getNetworkAuthUrl(8);
export const getTiktokCode = (id) => getNetworkAuthUrl(id);

export const getGoogleCode = () => {
    const scope = "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/business.manage openid https://www.googleapis.com/auth/business.manage"
    const url = `https://accounts.google.com/o/oauth2/auth/oauthchooseaccount?response_type=code&redirect_uri=${HOST_URL}/feeds/authCallback&client_id=${GOOGLE_CLIENT_ID}&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fplus.login%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fplus.business.manage&access_type=offline&approval_prompt=force&state=google&service=lso&o2v=1&flowName=GeneralOAuthFlow`;
    window.open(url, "_blank", "width=786, height=786");
}

export const getInstaCode = () => {
    const url = `https://api.instagram.com/oauth/authorize?client_id=${INSTA_CLIENT_ID}&redirect_uri=${HOST_URL}/feeds/authCallback/&scope=instagram_business_basic,instagram_business_manage_comments&response_type=code`;
    window.open(url, "_blank", "width=786,height=786");
}

export const getFbCode = (networkId) => {
    var scope = networkId == 3 ? `user_posts,pages_show_list,pages_manage_metadata,pages_read_engagement,pages_read_user_content,email,pages_manage_posts,public_profile,business_management` : `user_posts,pages_show_list,instagram_manage_insights,instagram_manage_comments,pages_manage_metadata,pages_read_engagement,pages_show_list,email,public_profile,instagram_basic,business_management`;
    const url = `https://www.facebook.com/v15.0/dialog/oauth?client_id=${FACEBOOK_CLIENT_ID}&redirect_uri=${`https://${LIVE_API ? "app" : "staging-app"}.socialwalls.com`}/feeds/authCallback&state=facebook&scope=${scope}`;
    window.open(url, "_blank", "width=786,height=786");
};


export const yammerCode = (token) => {
    localStorage.setItem('active_product', "display");
    const url = `https://www.yammer.com/dialog/oauth?client_id=${YAMMER_CLIENT_ID}&redirect_uri=${HOST_URL}/feeds/authCallback_yammer/&state=${token}`;
    window.open(url, "_blank", "width=786,height=786");
}

export const getSlackCode = () => {
    const token = 'connect';
    let url = `https://slack.com/oauth/authorize?client_id=${SLACK_CLIENT_ID}&scope=channels:history,groups:history,im:history,mpim:history,channels:read,groups:read,im:read,mpim:read,users.profile:read,users:read,files:read&state=${token}&redirect_uri=${HOST_URL}/feeds/authCallback_slack/`;
    window.open(url, "_blank", "width=786, height=786");
}

const getNetworkAuthUrl = (networkId) => {
    const accObj = {
        token: "w",
        code: '',
        networkId,
        reconnectAccount: 0,
        ownerId: window.location.pathname.includes('connection') ? localStorage.getItem('accountId') : localStorage.getItem('ownerId'),
        type: 4
    }

    addAccount(accObj).then(res => {
        const { responseData, responseCode, responseMessage } = res.data;
        if (responseCode == 200) {
            const isSafari = isAppleSafari();
            if (isSafari) {
                var a = document.createElement('a');
                a.href = responseData;
                a.setAttribute('target', '_blank');
                a.setAttribute('rel', 'opener');
                a.click();
            } else {
                window.open(responseData, "_blank", "width=786,height=786");
            }
            toast.success(responseMessage, { autoClose: 3000 });
        } else {
            toast.error(responseMessage, { autoClose: 3000 });
        }
    }).catch(err => {
        console.log(err?.response?.data?.responseMessage ?? "");
    });
}

export const getThreadCode = () => getNetworkAuthUrl(32)